import axios from 'axios'
import settings from '@/model/settings'
import log from '@/logger'
import shortid from 'shortid'
import store from '@/store'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import VueCookies from 'vue-cookies'
import Vue from 'vue'

Vue.use(VueCookies)

const url = settings.backend.url

const axiosApi = axios.create({
  baseURL: url,
  headers: {
    'Content-Type': 'application/json',
    //'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Credentials': true,
    // 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
    // Cookie: ".AspNetCore.Cookies=CfDJ8EEWrcpfwkBFi26BCPFHU0fm-udppqw9Aecjceegw5KjCI2lXp_IxG_q5Rd2UjO_pZgRQCCygrgRCnYD4ds1G1ySguvD-gDCEbiTZ16unBTfrRzpY1EbcVX8bZJ6MuZ_C8CVWfXcAxtHXm_vUjkFF-fhQiGjrIUnJJFvfJlAUnw5Yz7MHPMxQei8BJEMRY3SvWb931PC_juLS3z-fagXXtQAreh6o8AmKTM96yjPnQkhzvRjurVbFaY2JlKXKZcu7OAscblGYSINnxvktjIVe5izA_HObiDMULx_IOvcT-0G7oC4EIPOcwCiZwxalsxI-FwAGU3tqeOd3Ze1izQwrkQ"
  }
})

const refreshAuthLogic = failedRequest => {
  
  if(store.getters.user !== undefined){
    
    var user = store.getters.user
    console.log('Refresh logic running ' + user)        
    var refresh = {
      token: user.token,
      refreshToken: user.refreshToken,
    }   
    if(refresh.token === undefined || refresh.refreshToken === undefined){
      if(localStorage.getItem('vuex') !== null){
        localStorage.clear('vuex')  
      }
      //this.$router.push('start')
      setAuthHeader({}) 
      failedRequest.response.status = 401
      return Promise.reject(failedRequest)
    }
    return axiosApi.post('account/refresh',refresh,{ skipAuthRefresh: true })
      .then(response => {      
        console.log('Refresh repsonse')     
        console.log(response)
        if(response.status === 200){
          var user = response.data
          failedRequest.response.config.headers['Authorization'] = 'Bearer ' + user.token          
          store.commit('SET_USER',user)
          setAuthHeader(user.token)            
        
          return Promise.resolve()
        }
        else if(response.status === 403){
          setAuthHeader({})     
          localStorage.removeItem('vuex')
          return Promise.reject(failedRequest)
        }
      })
      .catch(error => {        
        console.log('Refresh error')     
        console.log(error)      
        setAuthHeader({})      
        localStorage.clear('vuex')                 
        return Promise.reject(failedRequest)           
      })                  
  }  
}

createAuthRefreshInterceptor(axiosApi, refreshAuthLogic,
  {
    pauseInstanceWhileRefreshing: false // default: false
  })
  

axiosApi.interceptors.request.use(
  request =>  {
    if(request.url !== '/account/login') {
      // Prefer the explicitly set default (via setAuthHeader) over the store token,
      // so impersonation token changes take effect immediately without a store update.
      const defaultAuth = axiosApi.defaults.headers.common['Authorization']
      request.headers['Authorization'] = defaultAuth || `Bearer ${getAccessToken()}`
    }
    var id = shortid.generate()
    request.headers['X-Request-Id'] = id
    return request 
  }
)
  // function(config) {    
  //   var id = shortid.generate()
  //   config.headers['X-Request-Id'] = id
  //   return config
  // }

axiosApi.interceptors.response.use(  
  function(response) { 
    return response
  },
  function(error) { 
    console.log(error)
    var id 
    if(error.config === undefined && error.headers !== undefined){
      id = error.headers['X-Request-Id']
    }
    else{
      if(error.config !== undefined){
        id = error.config.headers['X-Request-Id']
      }
    }
    
    var req = `[${id}]`
    if(!error.status){
      return Promise.reject(error)
    }
    if(error.response.status < 401 && error.response.status > 403 )
    {
        if (error.response) {
            //console.log(`ERROR`, error.response.data, error.response.status, error.response.headers)
            Vue.$toast.error(`${error.response.data.error} ${req}`)       
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          //console.log(error.request)
          Vue.$toast.error(`${error.request} ${req}`)
        } else {
          // Something happened in setting up the request that triggered an Error
          //console.log('Error', error.message)
          Vue.$toast.error(`${error.message} ${req}`)
        }
        console.log('AxiosConfig:', error.config)
        
        return Promise.reject(error)
    }
  }
)

// function responseErrorHandler(error) {
//   // check for errorHandle config
//   if( error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false ) {
//       return Promise.reject(error);
//   }

//   // if has response show the error
//   if (!error.response) {
//     EventBus.$emit('ERROR', `Network Error`);
//   } else if (error.response) {
//     EventBus.$emit('ERROR', `${error.response.status} ${error.response.data}`);
//   } else {
//     EventBus.$emit('ERROR', `Unknown error`);
//   }
// }
// axiosApi.interceptors.response.use(
//   response => response,
//   responseErrorHandler
// )
log.debug('Axios started with baseUrl: ', url)

// // https://www.qcode.in/api-error-handling-in-vue-with-axios/
// axiosApi.interceptors.response.use(
//   function(response) { 
//     return response
//   },
//   function(error) {
//       // handle error
//       // if (error.response) {
//       //     alert(error.response)
//       // }
//       if (error.response && error.response.status) {
//         switch(error.response.status) {
//           case 400: // Invalid ModelState
//             break
//           case 401:
//             alert('Not authenticated')
//             break
//           case 500:
//             //alert('500 - Internal Server Error... Unknown state of DynIvrLib... please restart on server side...')
//             break
//           default:
//             //alert(`Expected 200, got: ${error.response.status}`)
//             break
//         }
//       }
//   })

// export default axios.create({
//   baseURL: API_URL,
//   headers: {
//     'Content-Type': 'application/json',
//     'Authorization': `Bearer ${localStorage.getItem('user-token')}`
//   }
// })

export const setAuthHeader = (token) => {
  if(token === null){
    delete axiosApi.defaults.headers.common['Authorization']
  }
  else{   
    axiosApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
    // if(VueCookies.get('auth_token') !== token){    
    //   VueCookies.set('auth_token',token, null,null, 'kvallstidningarna.se')
    // }
  }
  
}

function getAccessToken(){
  if(store.getters.user.token === undefined){
    const token = VueCookies.get('auth_token')
    return token
  }  
  return store.getters.user.token
}

export const setResponseType=(type)=>{
  axiosApi.defaults.headers.common['Content-Type'] = type
}
// Set the initial header from storage or something (should surround with try catch in actual app)
// setAuthHeader(localStorage.getItem('user-token'))

export default axiosApi
